import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";

export const ModalThongbaoHanSuDung = (props) => {
    return (
        <Modal
            {...props}
            size="modal-dialog modalNewTT"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left popup-detail "
            backdrop="static"
        >
            <Modal.Body>
                <div style={{ textAlign: "center" }}>
                    <div class="icon-box">
                        <i class="mdi mdi-message-lock-outline"></i>
                    </div>
                    <h4>
                        Thông báo
                    </h4>
                    <p> Phần mềm của quý khách sẽ hết hạn sau <span style={{ color: "#c0392b" }}> {props.value} </span> ngày, vui lòng liên hệ nhân viên hỗ trợ để được hướng dẫn gia hạn.</p>
                    <p>
                        <a
                            className="btn btn-new-main btn-closenew"
                            data-dismiss="modal"
                            href={() => false}
                            onClick={props.hideThongBaoHanSuDung}
                        >
                            Tiếp tục sử dụng
                        </a>
                    </p>
                </div>
            </Modal.Body>
        </Modal>
    );
};
